import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "review" }
const _hoisted_2 = { class: "author" }
const _hoisted_3 = { class: "rate" }
const _hoisted_4 = { class: "float-right" }


import { IonCard, IonCardContent, IonIcon, IonRow, modalController } from "@ionic/vue";
import { star, starOutline } from "ionicons/icons";
import ReviewDetailModal from "../Modal/ReviewDetailModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductReviewComponent',
  props: { review: Object },
  setup(__props) {

const props = __props;

const openModal = async () => {
  
  const modal = await modalController.create({
    component: ReviewDetailModal,
    cssClass: "review-modal",
    componentProps: {
      review: props.review,
    },
  });
  modal.present();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { onClick: openModal }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, " \"" + _toDisplayString(__props.review?.description) + "\" ", 1),
          _createVNode(_unref(IonRow), { class: "justify-content-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(__props.review?.user?.profile?.nickName), 1),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(__props.review?.rating), (n) => {
                  return (_openBlock(), _createBlock(_unref(IonIcon), {
                    icon: _unref(star),
                    class: "yellow-star",
                    key: n
                  }, null, 8, ["icon"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(5 - __props.review?.rating), (n) => {
                  return (_openBlock(), _createBlock(_unref(IonIcon), {
                    icon: _unref(starOutline),
                    class: "black-star",
                    key: n
                  }, null, 8, ["icon"]))
                }), 128)),
                _createElementVNode("span", null, "(" + _toDisplayString(__props.review?.rating) + ")", 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(new Date(__props.review?.updatedAt).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})